export default {
add_achievements:[],
achievements:[],
edit_achievement:[],
};
